<template>
  <div>
    <div class="hooverbuttons">
      <button
        type="button"
        class="chat-btn soltak-chat-btn"
        aria-label="Åpne kontaktinfo"
        @click="showModal = true"
      >
        <span style="margin: 0">Kontakt oss</span>
        <!-- <svg>
          <use
            xlink:href="https://hkraft.no/wp-content/themes/hkraft/images/icons.svg#chat"
          ></use>
        </svg> -->
      </button>
    </div>

    <div
      class="modal"
      :class="{ 'is-visible': showModal }"
      id="modal1"
      @keyup.esc="showModal = false"
      @click.self="showModal = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Kontakt oss
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h4">Kontakt oss</legend>
          <p>
            Har du problemer med å bestille solcellepaneler til ditt tak? Har du
            lyst på et skreddersydd tilbud til flere tak? Eller kanskje du bare
            vil ha litt hjelp til å velge riktig?<br />Da kan du sende oss en
            e-post - så hjelper vi deg videre.
          </p>
          <a
            class="btn btn-solid btn-arrow btn-hk-blue-deep"
            href="mailto:solkraft@hkraft.no"
          >
            Send e-post
          </a>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactInformation',
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style>
.chat-btn.soltak-chat-btn {
  background-color: #003451;
  border-color: #003451;
  color: #fff;
}

@media (max-width: 47.99em) {
  .hooverbuttons {
    bottom: calc(1em + 4rem);
    padding: 0;
    position: fixed;
  }
}
</style>
